import type React from 'react';
import NavigationCard, { type NavigationCardProps } from 'app/ui/components/molecules/navigation-card';

import type { Resource } from 'app/types/graphql';

export type ResourceCardProps = NavigationCardProps & {
  resource: Resource;
  parentResourceListId?: string;
};

const ResourceCard: React.FC<ResourceCardProps> = ({
  resource: { id, title, content },
  parentResourceListId,
  ...navigationCardProps
}) => {
  return (
    <NavigationCard
      {...navigationCardProps}
      url={`/resources/${id}?resourceListId=${parentResourceListId}`}
      title={title}
      content={content || undefined}
    />
  );
};

export default ResourceCard;
